import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Data } from "@angular/router";
import { CommonService } from '@services/app.common.service';
import { StatusCode, SSOType } from '../_shared/_enums/Common';
import { ResponseToken } from '../login/Interface/response-token.interface';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
})

export class LogoutComponent implements OnInit {
  data = [];
  forcefullyStop: boolean = false;
  showLoader = false;
  StatusCode = StatusCode;
  ssoConfig;
  forgeryToken: string = '';
  isJTGO = false;
  token: string = '';
  showMobileLink: boolean = false;
  mobileSiteUrl: string = '';
  copyRight: string = '';
  tokenResponse = {} as ResponseToken;

  constructor(private router: Router, public common: CommonService, private route: ActivatedRoute,) {
    this.ssoConfig = this.common.ssoConfig;
    this.route.data.subscribe((data: Data) => {
      this.tokenResponse = data['tokenAnonymousResponse'];
      this.token = `Bearer ${this.tokenResponse.resultData}`;
    });
  }

  ngOnInit() {
    this.copyRight = "1998 - " + new Date().getFullYear() + this.common.GetTranslation('Login.Footer')
    this.common.RemoveAccessToken();
    this.ssoConfig = this.common.ssoConfig;
    const clientSetting = this.common.getClientSettings();
    this.isJTGO = clientSetting.IsJTGO;
    this.LoadLoginConfiguration();
  }
  goToMobile(): void {
    window.open(this.mobileSiteUrl, '_blank');
  }
  OktaLogin() {
    window.location.href = this.common.ApiUrls.Login.OktaLogin;
    return false;
  }
  private LoadLoginConfiguration(): void {
    var $this = this;
    this.common.GetData(this.common.ApiUrls.AnonymousUser.LoadLoginConfiguration, false, this.token).then(function (data) {
      if (data.status == StatusCode.OK) {
        if (data.resultData.showMobileLink == 1) {
          $this.showMobileLink = true;
          $this.mobileSiteUrl = data.resultData.mobileSiteUrl;
        }
      }
    });
  }
}
